import { Injectable, Optional } from '@angular/core';

@Injectable()
export class StyleInjectorService {
  private stylesMap: Map<any, Node> = new Map();
  private host: any;

  constructor() {
    this.host = document.head;
  }

  createStyleNode(content: string): Node {
    const styleEl = document.createElement('style');
    styleEl.textContent = content;
    return styleEl;
  }

  has(key: any): boolean {
    return this.stylesMap.has(key);
  }

  addStyle(key: any, style: string): void {
    const styleEl = this.createStyleNode(style);
    this.stylesMap.set(key, styleEl);
    this.host.appendChild(styleEl);
  }

  removeStyle(key: any): void {
    const styleEl = this.stylesMap.get(key);
    if (styleEl) {
      this.stylesMap.delete(key);
      this.host.removeChild(styleEl);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/style-injector.service.ts